<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <install-prompt></install-prompt>
          <h2 class="title" style="margin-bottom:80px;" color>
            {{ $t("truthOrDrink.title") }}
          </h2>
          <base-modal
            :title="modalTitle"
            :message="modalMessage"
            :showModal="showModal"
            @close-modal="showModal = false"
          />
          <h4 class="title" style="height: 30px; margin-bottom:120px;" color>
            {{ currentPhrase }}
          </h4>
          <div
            class="row"
            style="justify-content: space-evenly; margin-bottom:10px;"
          >
            <button
              class="btn btn-base btn-fill float-middle"
              @click="drawnRandomPhrase('normal')"
            >
              {{ $t("truthOrDrink.normalButton") }}
            </button>
            <button
              class="btn btn-base btn-fill float-middle"
              @click="drawnRandomPhrase('party')"
            >
              {{ $t("truthOrDrink.partyButton") }}
            </button>
          </div>
          <div
            class="row"
            style="justify-content: space-evenly; margin-bottom:10px;"
          >
            <button
              class="btn btn-base btn-fill float-middle"
              @click="drawnRandomPhrase('dirty')"
            >
              {{ $t("truthOrDrink.dirtyButton") }}
            </button>
            <button
              class="btn btn-base btn-fill float-middle"
              @click="drawnRandomPhrase('intimate')"
            >
              {{ $t("truthOrDrink.intimateButton") }}
            </button>
          </div>

          <div slot="footer" style="width:100%">
            <share-footer />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mixin } from "src/mixin";
import ShareFooter from "src/components/ShareFooter.vue";

import { normalPhrases as normalPhrasesEn } from "./phrases/en/normal";
import { partyPhrases as partyPhrasesEn } from "./phrases/en/party";
import { dirtyPhrases as dirtyPhrasesEn } from "./phrases/en/dirty";
import { intimatePhrases as intimatePhrasesEn } from "./phrases/en/intimate";

export default {
  mixins: [mixin],

  components: {
    ShareFooter,
  },

  data() {
    return {
      currentPhrase: this.$t("truthOrDrink.initialPhrase"),
    };
  },

  beforeMount() {
    const normalPhrasesPt = [];
    const partyPhrasesPt = [];
    const dirtyPhrasesPt = [];
    const intimatePhrasesPt = [null];
    if (this.linguaPortuguesa) {
      this.normalPhrases = normalPhrasesPt;
      this.partyPhrases = partyPhrasesPt;
      this.dirtyPhrases = dirtyPhrasesPt;
      this.intimatePhrases = intimatePhrasesPt;
    } else {
      this.normalPhrases = normalPhrasesEn;
      this.partyPhrases = partyPhrasesEn;
      this.dirtyPhrases = dirtyPhrasesEn;
      this.intimatePhrases = intimatePhrasesEn;
    }
  },

  methods: {
    drawnRandomPhrase(type) {
      switch (type) {
        case "normal":
          this.currentPhrase = this.normalPhrases[
            Math.floor(Math.random() * this.normalPhrases.length)
          ];
          break;
        case "party":
          this.currentPhrase = this.partyPhrases[
            Math.floor(Math.random() * this.partyPhrases.length)
          ];
          break;
        case "dirty":
          this.currentPhrase = this.dirtyPhrases[
            Math.floor(Math.random() * this.dirtyPhrases.length)
          ];
          break;
        case "intimate":
          this.currentPhrase = this.intimatePhrases[
            Math.floor(Math.random() * this.intimatePhrases.length)
          ];
          break;
        default:
          console.error("Can't find this type of deck");
      }
    },
  },
};
</script>

<style>
.title {
  text-align: center;
}
.description {
  text-align: left;
}
</style>
